const { API_BASE_PATH, INTER_BROKER_WEB_PATH, CMS_API_PATH, WEB_API_PATH } = {
  API_BASE_PATH: process.env.API_BASE_PATH,
  INTER_BROKER_WEB_PATH: process.env.INTER_BROKER_WEB_PATH,
  CMS_API_PATH: process.env.CMS_API_PATH,
  WEB_API_PATH: process.env.WEB_API_PATH,
}

export { API_BASE_PATH, INTER_BROKER_WEB_PATH, CMS_API_PATH, WEB_API_PATH }
//
export const QUOTES_AND_INDICES = `${API_BASE_PATH}/acoes-destaques-mobile/acoes-em-destaques.json`
export const INTER_BROKER_PATH = `${INTER_BROKER_WEB_PATH}/institucional/contato/v2/canais`
export const CMS_API_QUOTATIONS = `${WEB_API_PATH}/api/invest/history`
export const FORMPOST = `${INTER_BROKER_WEB_PATH}/institucional/contato/v2`
